import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import WcbDateSelect from './WcbDateSelect';
import WcbTimeSelect from './WcbTimeSelect';
import { IconDatePickerOutlined } from '../common/svgicons/DatePickerOutlined';
import { IconClockOutlined } from '../common/svgicons/ClockOutlined';

type WcbDateTimeContainerProps = {
    iimclient: ConfigClientType;
    showContainer: boolean;
    wcbDates: Array<string>;
    wcbTimes: Array<string>;
    wcbDateErrorVisible: boolean;
    wcbTimeErrorVisible: boolean;
    changeSelectedDate: Function;
    changeSelectedTime: Function;
};

const WcbDateTimeContainer = ({
    iimclient,
    showContainer,
    wcbDates,
    wcbTimes,
    wcbDateErrorVisible,
    wcbTimeErrorVisible,
    changeSelectedDate,
    changeSelectedTime,
}: WcbDateTimeContainerProps) => {
    const { segment } = iimclient;

    const dateRequiredLabel = (segment && segment.daterequired) || '';
    const timeRequiredLabel = (segment && segment.timerequired) || '';
    const dateTimeLabel = (segment && segment.labeldatetime) || 'wcb-labeldatetime';

    return (
        showContainer && (
            <div className="input-block" id="wcb-datetime-container">
                <label htmlFor="wcb-date" id="wcb-labeldatetime">
                    {dateTimeLabel}
                </label>
                <div className="wrapper">
                    <div className="select-input date">
                        <WcbDateSelect
                            iimclient={iimclient}
                            wcbDates={wcbDates}
                            changeSelectedDate={changeSelectedDate}
                        />
                        {/* <IconDatePickerOutlined width="28px" height="28px" color="#333" /> */}
                    </div>
                    <div className="select-input time">
                        <WcbTimeSelect
                            iimclient={iimclient}
                            wcbTimes={wcbTimes}
                            changeSelectedTime={changeSelectedTime}
                        />
                        {/* <IconClockOutlined width="28px" height="28px" color="#333" /> */}
                    </div>
                </div>
                {wcbDateErrorVisible && (
                    <span id="wcb-date-error" className="errorMessage">
                        {dateRequiredLabel}
                    </span>
                )}
                {wcbTimeErrorVisible && (
                    <span id="wcb-time-error" className="errorMessage">
                        {timeRequiredLabel}
                    </span>
                )}
            </div>
        )
    );
};

export default WcbDateTimeContainer;
